import { Component } from '@angular/core';
import { NavController, ModalController, AlertController } from 'ionic-angular';


import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';

import { CalendarioPage } from '../../pages/calendario/calendario';
import { LoginPage } from '../../pages/login/login';
import { TrabajadoresPage } from '../../pages/trabajadores/trabajadores';
import { HomePage } from '../../pages/home/home';
import { InformesPage } from '../../pages/informes/informes';
import { ListPage } from '../../pages/list/list';
import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { CalendarComponentOptions } from 'ion2-calendar'

/**
 * Generated class for the BotoneraComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'botonera',
  templateUrl: 'botonera.html'
})
export class BotoneraComponent {

  obras;
  text: string;
  valo="654321123456" ;
   date: string;
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'



  constructor(
    public modalCtrl: ModalController,
  	public navCtrl: NavController,
    public funciones:FuncionesProvider,
  	public variables:VariablesProvider
  	) {


  }




  openInicio(){ 
    this.navCtrl.push(ListPage); 
  }
 openhome(){ 
    this.navCtrl.push(HomePage); 
  }
  opentrabajadores(){ 
  	this.navCtrl.push(TrabajadoresPage); 
  }

   opencalendario(){ 
    this.navCtrl.push(CalendarioPage); 
  }


   openinformes(){ 
    this.navCtrl.push(InformesPage); 
  }

 preparaimprimir(){ 
   this.variables.imprimir=true;

  }

 comoestaba(){ 
   this.variables.imprimir=false;

  }

  openconfiguracion(){ 

  }

   goBack(){
    this.navCtrl.pop();
  }




}



// WEBPACK FOOTER //
// ./src/components/botonera/botonera.ts